import { NamedNode } from './node';

export class Address extends NamedNode {
    street?: string;
    zip?: string
    city?: string;
    state?: string;
    country?: string;
}
